import PropTypes from 'prop-types';
import React from 'react';
import shallowEqual from 'shallowequal';
import classnames from 'classnames';
import _ from 'lodash';

import GoogleMapsHelper from '../helpers/GoogleMaps';
import { translate as t } from '../lib/I18n';

import Icon from './general/Icon';

class MapComponent extends React.Component {

    static propTypes = {
        className: PropTypes.string,
        style: PropTypes.object,
        children: PropTypes.any,
        allowMapExpand: PropTypes.bool,
        onReady: PropTypes.func,
        stationFinderActive: PropTypes.bool
    };

    static defaultProps = {
        allowMapExpand: true,
        className: '',
        style: {},
        onReady: _.noop,
        stationFinderActive: false
    };

    state = {
        loaded: false,
        expandMap: false
    };

    /**
     * Pure render mixin shallow compares, so doesn't know if children change,
     * so we check if the props on the children have changed and if their keys match,
     * so to reduce requests, all children to this component need keys.
     */
    shouldComponentUpdate (nextProps, nextState) {
        let nextChildren = [];
        let currentChildren = [];
        React.Children.forEach(nextProps.children, child => nextChildren.push(child));
        React.Children.forEach(this.props.children, child => currentChildren.push(child));

        let childrenChanged = nextChildren.reduce((out, child) => {
            let matched = currentChildren.filter(existing => child.key === existing.key);
            if (!matched || !matched.length) { return true; }
            return out || !shallowEqual(matched[0].props, child.props);
        }, false);

        return !shallowEqual(this.state, nextState) || childrenChanged;
    }

    componentDidMount () {
        this.mapsHelper = new GoogleMapsHelper(this.refs.map, this._onMapLoaded);
        this.props.onReady(this.mapsHelper);
    }

    componentDidUpdate () {
        if (this.state.loaded && !this.props.stationFinderActive) {
            this.mapsHelper.fitBounds();
        }
    }

    _onMapLoaded = () => {
        this.setState({ loaded: true });
    };

    _renderChildren() {
        if (!this.state.loaded) { return null; }

        return React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child, {
                key: index,
                mapsHelper: this.mapsHelper
            });
        });
    }

    _toggleMapExpand = () => {
        this.setState({ expandMap: !this.state.expandMap }, () => {
            setTimeout(() => {
                this.mapsHelper.resize();
                this.mapsHelper.fitBounds();
            }, 1);
        });
    };

    render () {
        let style = { width: '100%', height: '100%' };
        const classNames = classnames(this.props.className, {'right-col--expand-map': this.state.expandMap});
        const { allowMapExpand } = this.props;
        if (this.state.loaded) { this.mapsHelper.refresh(); }

        const buttonClass = classnames('map-expander box box--rounded box--padded', {
            'map-expander--active': this.state.expandMap
        });

        return (
            <div className={ classNames } style={ this.props.style }>
                { this._renderChildren() }

                <div style={ style } ref="map" />

                { allowMapExpand && (
                    <button
                        className={ buttonClass }
                        type="button"
                        aria-label={ t('ariaLabel.toggleMap') }
                        onClick={ this._toggleMapExpand }
                    >
                        <Icon icon="arrowback" className="otrl-rotate-45" />
                        <Icon icon="arrowback" className="otrl-rotate-225"/>
                    </button>
                ) }
            </div>
        );
    }

}

export default MapComponent;



// WEBPACK FOOTER //
// ./src/components/Map.js